import { presentConditionKeys } from '../serviceConditionDisplay';
export const operatorLabel = (quantifier, isHas, t)=>{
    const isNone = quantifier === 'none';
    if (isHas) return isNone ? t.servicesOperatorHasNo() : t.servicesOperatorHas();
    return isNone ? t.servicesOperatorIsNot() : t.servicesOperatorIs();
};
export const isSoleNameCondition = (predicate)=>{
    var _ref;
    var _predicate_or;
    if (predicate.not != null || ((_ref = (_predicate_or = predicate.or) === null || _predicate_or === void 0 ? void 0 : _predicate_or.length) !== null && _ref !== void 0 ? _ref : 0) > 0) return false;
    const keys = presentConditionKeys(predicate);
    return keys.length === 1 && keys[0] === 'name';
};
export const serviceNamePredicate = (name)=>({
        name: {
            exact: name
        }
    });
export const currentServiceName = (predicate)=>{
    var _ref, _ref1, _ref2, _ref3;
    const name = predicate.name;
    return (_ref = (_ref1 = (_ref2 = (_ref3 = name === null || name === void 0 ? void 0 : name.exact) !== null && _ref3 !== void 0 ? _ref3 : name === null || name === void 0 ? void 0 : name.contains) !== null && _ref2 !== void 0 ? _ref2 : name === null || name === void 0 ? void 0 : name.fuzzy) !== null && _ref1 !== void 0 ? _ref1 : name === null || name === void 0 ? void 0 : name.startsWith) !== null && _ref !== void 0 ? _ref : null;
};
